import React, { useState, Component, useEffect, useRef } from 'react';

import withAuth from '../../components/withAuth';

import { getText, multiLine } from '../../i18n/i18next';

import { Row, Col, Skeleton, Badge, Tooltip, Card, Divider, Dropdown, Menu, Empty, Message, Notification, Pagination, Modal, Switch, Button, TreeSelect } from './../base';
import history from './../history';

import { subscribeUserNotification, stopSignalR, upsertMessage, markAllMessagesAsRead, deleteAllMessages, getMessage, unfollowNotification, getMessageDate, getUserProfileAvailableEventCodes, loadBookingApprovalRemarkImage, loadBookingApprovalRemarkImage2, loadConsolidationRemarkImage, loadConsolidationRemarkImage2, loadMessengerMessageFullDescImage, loadMessengerMessageFullDescImage2 } from './common';
import { CheckIsNullOrUndefined } from './../Common';
import SearchBoxWithAutoComplete from './../SearchBoxWithAutoComplete';

import AuthService from './../AuthService';

import './NotificationBellButtonGroup.scss';
import { BellOutlined, BellFilled, CheckOutlined, DeleteOutlined, SyncOutlined, SettingOutlined, FullscreenOutlined, DoubleRightOutlined, DoubleLeftOutlined, SearchOutlined, MoreOutlined, LeftOutlined, DisconnectOutlined, FileOutlined, BookOutlined, CheckCircleOutlined, ClusterOutlined, FilePptOutlined, ReconciliationOutlined, MessageOutlined, InboxOutlined, FormOutlined, SendOutlined, DownOutlined } from '@ant-design/icons';

import 'braft-editor/dist/output.css'

//const masterListUrl = `${process.env.PUBLIC_URL}/BMS/Notification/masterList`;
const confirm = Modal.confirm;

const getModuleIcon = (module, sub_module) => {
    if (module === 'invoice') {
        return <FileOutlined />;
    } else if (module === 'booking' && sub_module === 'booking') {
        return <BookOutlined />;
    } else if (module === 'booking' && sub_module === 'booking approval') {
        return <CheckCircleOutlined />;
    } else if (['consolidation', 'sync_consolidation_data'].includes(module)) {
        return <ClusterOutlined />;
    } else if (module === 'prs') {
        return <FilePptOutlined />;
    } else if (module === 'sopms') {
        return <ReconciliationOutlined />;
    } else if (module === 'messenger') {
        return <MessageOutlined />;
    }
}

const getCategoryFilterAccess = availableEventCodes => {
    const bookingAccess = availableEventCodes.some(c => c.module === 'booking' && c.sub_module === 'booking');
    const bookingApprovalAccess = availableEventCodes.some(c => c.module === 'booking' && c.sub_module === 'booking approval');
    const consolidationAccess = availableEventCodes.some(c => c.module === 'consolidation' || c.module === 'sync_consolidation_data');
    const messengerAccess = availableEventCodes.some(c => c.module === 'messenger');
    const webinvoiceAccess = availableEventCodes.some(c => c.module === 'web_invoice' && c.sub_module === 'auto_ap_reference');
    const webinvoiceErrorMessageAcccess = availableEventCodes.some(c => c.module === 'web_invoice' && c.sub_module === 'web-Invoice_err_msg_notice');
    const otherAccess = availableEventCodes.some(c =>
        !(c.module === 'booking' && c.sub_module === 'booking') && !(c.module === 'booking' && c.sub_module === 'booking approval') &&
        !(c.module === 'consolidation' || c.module === 'sync_consolidation_data') && !(c.module === 'messenger') &&
        !(c.module === 'web_invoice' && c.sub_module === 'auto_ap_reference') &&
        !(c.module === 'web_invoice' && c.sub_module === 'web-Invoice_err_msg_notice')
    );
    return { bookingAccess, bookingApprovalAccess, consolidationAccess, messengerAccess, webinvoiceAccess, webinvoiceErrorMessageAcccess, otherAccess };
}

const getCategoryTreeValues = nodes => nodes.flatMap(node => node.children ? getCategoryTreeValues(node.children) : [node.value]);

const Auth = new AuthService();

const messengerAccess = Auth.isAccessable('m_messenger', 'messenger');

const statusUpdateDescKeys = ["notification.msgETDDelayPOLDate", "notification.msgETDDelayTSPortDate", "notification.msgRolloverPOLDate", "notification.msgRolloverTSPortDate"];

const checkClickOutsideNotificationList = setNotificationListVisible => {
    const [clientAdded , setClientAdded] = useState(false);

    if (!clientAdded) {
        setClientAdded(true);
        
        document.addEventListener("mousedown", (evt) => {
            let targetElement = evt.target; // mousedowned element
            let isClickInsideElement = false;
        
            do {
                isClickInsideElement = targetElement && typeof targetElement.className === 'string' && (targetElement.className || '').includes("notificationInsideElement");

                // Go up the DOM
                targetElement = targetElement.parentNode;
            } while (targetElement && !isClickInsideElement);
        
            //console.log(isClickInsideElement ? 'in' : 'out')

            if (!isClickInsideElement) {
                //Do something click is outside specified element
                setNotificationListVisible(false);
            }
        });
    }
}

const BellButton = props => {
    const { notificationListVisible, setNotificationListVisible, countUnread } = props;

    const handleOnClickBell = () => {
        setNotificationListVisible(!notificationListVisible);
    }

    return (
        <Badge count={countUnread} className="notificationInsideElement bellBadge" onClick={handleOnClickBell}>
            <Tooltip placement="topRight" title={getText('notification.bellButtonToolTip')}>
                {
                    notificationListVisible ?
                        <BellFilled style={{ color: "#1963ae" }} />
                        :
                        <BellOutlined />
                }
            </Tooltip>
        </Badge>
    );
}

export const NotificationList = props => {
    const { notificationListVisible, messages, countUnread, loading, readFilter, categoryFilter, setCategoryFilter, searchText, pagination, availableEventCodes } = props;
    const { refreshUserNotification, setNotificationListVisible, setMessages, setCountUnread, setReadFilter, setSearchText, setPagination, updateReadStatus, setAvailableCategoryFilterValues } = props;

    checkClickOutsideNotificationList(setNotificationListVisible);

    const [searchBoxVisible, setSearchBoxVisible] = useState(false);
    const [isExpandWidth, setIsExpandWidth] = useState(false);
    const categoryFilterDebounceRef = useRef(null);
    
    const markAllAsRead = async () => {
        let isUpdateSuccess = await markAllMessagesAsRead();
        if (isUpdateSuccess) {
            let newMessages = messages.map(i => ({ ...i, is_read: true }));
            setMessages(newMessages);
            setCountUnread(0);
        }
    }

    const onSearchText = searchText => {
        setSearchText(searchText);
        refreshUserNotification(readFilter, searchText, pagination.pageSize, 1);
    }

    /*const handleOnShowSizeChange = (current, pageSize) => {
        let newPagination = { ...pagination };
        newPagination.current = current;
        newPagination.pageSize = pageSize;
        setPagination(newPagination);
        refreshUserNotification(readFilter, searchText, pageSize, current);
        console.log(current, pageSize)
    }*/
    
    const handleOnPageChange = (page, pageSize) => {
        let newPagination = { ...pagination };
        newPagination.current = page;
        newPagination.pageSize = pageSize;
        setPagination(newPagination);
        refreshUserNotification(readFilter, searchText, pageSize, page);
    };

    const handleSwitchreadFilter = newreadFilter => {
        let newPagination = { ...pagination };
        newPagination.current = 1;
        setPagination(newPagination);
        setReadFilter(newreadFilter);
        refreshUserNotification(newreadFilter, searchText, newPagination.pageSize, 1);
    }

    const handleCategoryFilterChange = value => {
        setCategoryFilter(value);
        if (categoryFilterDebounceRef.current) {
            clearTimeout(categoryFilterDebounceRef.current);
        }
        categoryFilterDebounceRef.current = setTimeout(() => {
            let newPagination = { ...pagination };
            newPagination.current = 1;
            setPagination(newPagination);
            refreshUserNotification(readFilter, searchText, newPagination.pageSize, 1, value);
        }, 2000);
    }

    const categoryFilterOptions = {
        All: getText("notification.lblCategoryFilterAll"),
        Booking: getText("notification.lblCategoryFilterBooking"),
        BookingApproval: getText("notification.lblCategoryFilterBookingApproval"),
        Consolidation: getText("notification.lblCategoryFilterConsolidation"),
        Conversation: getText("notification.lblCategoryFilterConversation"),
        EnhancementNotice: getText("notification.lblCategoryFilterEnhancementNotice"),
        SystemMaintenance: getText("notification.lblCategoryFilterSystemMaintenance"),
        WebInvoice: getText("notification.lblCategoryFilterWebInvoice"),
        WebInvoiceErrorMessageNotice: getText("notification.lblCategoryFilterWebInvoiceErrorMessageNotice"),
        Other: getText("notification.lblCategoryFilterOther")
    };

    const categoryFilterModules = {
        Booking: ['booking', 'booking'],
        BookingApproval: ['booking', 'booking approval'],
        Consolidation: ['consolidation'],
        Inbox: ['messenger'],
        WebInvoice: ['invoice'],
        WebInvoiceErrorMessageNotice: ['invoice']
    };

    const categoryItemIcon = key => {
        const m = categoryFilterModules[key];
        const icon = m && getModuleIcon(m[0], m[1]);
        return icon ? <>{icon}&nbsp;</> : null;
    };

    const { bookingAccess, bookingApprovalAccess, consolidationAccess, messengerAccess, webinvoiceAccess, webinvoiceErrorMessageAcccess, otherAccess } = getCategoryFilterAccess(availableEventCodes);
    const enableCategoryFilter = [
        bookingAccess, bookingApprovalAccess, consolidationAccess, messengerAccess, webinvoiceAccess, webinvoiceErrorMessageAcccess, otherAccess
    ].filter(a => a).length > 1;

    const categoryTreeData = [
        {
            value: 'All',
            title: categoryFilterOptions.All,
            children: [
                bookingAccess && !bookingApprovalAccess && { value: 'Booking', title: <>{categoryItemIcon("Booking")}{categoryFilterOptions.Booking}</> },
                !bookingAccess && bookingApprovalAccess && { value: 'BookingApproval', title: <>{categoryItemIcon("BookingApproval")}{categoryFilterOptions.BookingApproval}</> },
                bookingAccess && bookingApprovalAccess && {
                    value: 'BookingGroup',
                    title: getText("notification.lblCategoryFilterBookingHeader"),
                    children: [
                        { value: 'Booking', title: <>{categoryItemIcon("Booking")}{categoryFilterOptions.Booking}</> },
                        { value: 'BookingApproval', title: <>{categoryItemIcon("BookingApproval")}{categoryFilterOptions.BookingApproval}</> }
                    ]
                },
                consolidationAccess && { value: 'Consolidation', title: <>{categoryItemIcon("Consolidation")}{categoryFilterOptions.Consolidation}</> },
                messengerAccess && {
                    value: 'InboxGroup',
                    title: <>{categoryItemIcon("Inbox")}&nbsp;{getText("notification.lblCategoryFilterInboxHeader")}</>,
                    children: [
                        { value: 'Conversation', title: categoryFilterOptions.Conversation },
                        { value: 'EnhancementNotice', title: categoryFilterOptions.EnhancementNotice },
                        { value: 'SystemMaintenance', title: categoryFilterOptions.SystemMaintenance }
                    ]
                },
                webinvoiceAccess && !webinvoiceErrorMessageAcccess && { value: 'WebInvoice', title: <>{categoryItemIcon("WebInvoice")}{categoryFilterOptions.WebInvoice}</> },
                !webinvoiceAccess && webinvoiceErrorMessageAcccess && { value: 'WebInvoiceErrorMessageNotice', title: <>{categoryItemIcon("WebInvoiceErrorMessageNotice")}{categoryFilterOptions.WebInvoiceErrorMessageNotice}</> },
                webinvoiceAccess && webinvoiceErrorMessageAcccess && {
                    value: 'WebInvoiceGroup',
                    title: getText("notification.lblCategoryFilterWebInvoiceHeader"),
                    children: [
                        { value: 'WebInvoice', title: <>{categoryItemIcon("WebInvoice")}{categoryFilterOptions.WebInvoice}</> },
                        { value: 'WebInvoiceErrorMessageNotice', title: <>{categoryItemIcon("WebInvoiceErrorMessageNotice")}{categoryFilterOptions.WebInvoiceErrorMessageNotice}</> }
                    ]
                },
                otherAccess && { value: 'Other', title: categoryFilterOptions.Other }
            ].filter(c => c !== false)
        }
    ];

    const availableCategoryFilterValues = getCategoryTreeValues(categoryTreeData[0].children);

    useEffect(() => {
        setAvailableCategoryFilterValues(availableCategoryFilterValues);
    }, [availableCategoryFilterValues.join(",")]);

    const messengerMenuUrls = {
        inbox: '/BMS/Messenger/inbox/',
        newMessage: '/BMS/Messenger/message/new',
        sentMessages: '/BMS/Messenger/sent_messages/'
    };

    const handleMessengerMenuClick = e => {
        let url = messengerMenuUrls[e.key];
        if (url) {
            history.push(`${process.env.PUBLIC_URL}${url}`);
            setNotificationListVisible(false);
        }
    }

    const handleMenuClick = e => {
        switch (e.key) {
            case "markAllAsRead":
                markAllAsRead();
                break;
            case "deleteAll":
                confirm({
                    className: 'notificationInsideElement',
                    title: getText('notification.msgSureToDeleteAll'),
                    centered: true,
                    cancelText: getText('lblNo'),
                    okText: getText('lblYes'),
                    onOk: handleDeleteAllMessages,
                    maskClosable: true
                });
                break;
            //case "masterList":
                //console.log('click', e.item.props.children);
                //history.push(`${process.env.PUBLIC_URL}/BMS/Notification/masterList`);
                //setNotificationListVisible(false);
                //break;
            case "refreseh":
                onSearchText(searchText);
                break;
            case "userDefaultSetting":
                history.push(`${process.env.PUBLIC_URL}/BMS/Notification/masterSetting`);
                setNotificationListVisible(false);
                break;
            default:
                console.log('click');
        }
    }

    const handleOnClickSearch = () => setSearchBoxVisible(true);

    const handleOnClickBack = () => { 
        setSearchBoxVisible(false);
        if (searchText !== '') {
            onSearchText("");
        }
    }
    
    const handleOnClickExpandWidth = () => setIsExpandWidth(!isExpandWidth);

    const handleDeleteAllMessages = async () => {
        let isUpdateSuccess = await deleteAllMessages();
        if (isUpdateSuccess) {
            setMessages([]);
            setCountUnread(0);
        }

        let newPagination = { ...pagination };
        newPagination.current = 1;
        newPagination.total = 0;
        setPagination(newPagination);
    };

    const menu = (
        <Menu onClick={handleMenuClick} className='notificationInsideElement'>
            <Menu.Item key="markAllAsRead">
                <CheckOutlined />&nbsp;
                {getText('notification.lblNotificationListMenuOption1')}
            </Menu.Item>
            <Menu.Item key="deleteAll">
                <DeleteOutlined />&nbsp;
                {getText('notification.lblNotificationListMenuOption2')}
            </Menu.Item>
            <Menu.Item key="refreseh">
                <SyncOutlined />&nbsp;
                {getText('notification.lblNotificationListMenuOption3')}
            </Menu.Item>
            {/*
                <Menu.Item key="userDefaultSetting">
                    <SettingOutlined />&nbsp;
                    {getText('notification.lblNotificationListMenuOption4')}
                </Menu.Item>
            */}
            <Menu.Item key="userDefaultSetting">
                <FullscreenOutlined />&nbsp;
                {getText('notification.lblNotificationListMenuOption4')}
            </Menu.Item>
        </Menu>
    );
    
    return (
        <Card className={`${isExpandWidth ? "expandWidth" : "normalWidth"} notificationInsideElement notificationListPopUp`} style={notificationListVisible ? {} : { display: 'none' }}>
            <Row className={"notificationInsideElement"} type="flex" style={{ overflowX: 'hidden' }}>
                <h2 className="slideIn" data-title-visible={!searchBoxVisible}>
                    {getText('notification.lblNotificationListTitle')}
                    <Switch 
                        style={{ marginLeft: '5px' }}
                        checkedChildren={getText("notification.lblReadFilterAll")} 
                        unCheckedChildren={getText("notification.lblReadFilterUnread")} 
                        onChange={checked => handleSwitchreadFilter(checked ? 'All' : 'Unread')}
                        checked={readFilter === 'All'} 
                    />
                    {
                        messengerAccess &&
                        <Dropdown
                            overlay={
                                <Menu onClick={handleMessengerMenuClick} className='notificationInsideElement'>
                                    <Menu.Item key="inbox"><InboxOutlined />&nbsp;Inbox</Menu.Item>
                                    <Menu.Item key="newMessage"><FormOutlined />&nbsp;Create New Message</Menu.Item>
                                    <Menu.Item key="sentMessages"><SendOutlined />&nbsp;Sent Messages</Menu.Item>
                                </Menu>
                            }
                            trigger={['hover']}
                            placement="bottomLeft"
                        >
                            <MessageOutlined style={{ marginLeft: '5px', fontSize: '0.8em' }} />
                        </Dropdown>
                    }
                    <div style={{ marginLeft: 'auto' }}>
                        {
                            isExpandWidth ?
                                <DoubleRightOutlined onClick={handleOnClickExpandWidth} />
                                :
                                <DoubleLeftOutlined onClick={handleOnClickExpandWidth} />
                        }
                        <SearchOutlined onClick={handleOnClickSearch} />
                        <Dropdown overlay={menu} trigger={['click']} align={{ offset: ['-85%', 0] }} >
                            <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                <MoreOutlined style={{ transform: 'rotate(90deg)' }}/>
                            </a>
                        </Dropdown>
                    </div>
                </h2>
                <h2 className="slideIn" data-searchbox-visible={searchBoxVisible}>
                    <LeftOutlined onClick={handleOnClickBack} />
                    <Tooltip
                        placement="topLeft"
                        title={multiLine(getText('notification.smartSearchTooltip'))}
                        overlayClassName="searchBox"
                    >
                        <div style={{ width: 'calc(100% - 46px)' }}>
                            <SearchBoxWithAutoComplete
                                name="searchNotificationText"
                                value={searchText}
                                allowClear={false}
                                optionClassName={"notificationInsideElement"}
                                style={{ flex: 1, textAlign: 'left' }}
                                onClick={() => onSearchText(searchText)}
                                onChange={setSearchText}
                            />
                        </div>
                    </Tooltip>
                </h2>
            </Row>
            <Row className="notificationListFilter" wrap={false}>
                <Col>
                    <Button 
                        type="text" 
                        data-read-filter-selected={readFilter === 'All'} 
                        onClick={() => handleSwitchreadFilter('All')}
                    >
                        {getText("notification.lblReadFilterAll")}
                    </Button>
                </Col>
                <Col>
                    <Button 
                        type="text" 
                        data-read-filter-selected={readFilter === 'Unread'} 
                        onClick={() => handleSwitchreadFilter('Unread')}
                    >
                        {getText("notification.lblReadFilterUnread")}
                    </Button>
                </Col>
                <Col flex="auto" style={{ position: 'relative' }}>
                    {
                        enableCategoryFilter &&
                        <>
                            <span>{getText("notification.lblCategoryFilterHeader")}:&nbsp;</span>
                            <TreeSelect
                                treeData={categoryTreeData}
                                value={categoryFilter}
                                onChange={handleCategoryFilterChange}
                                treeCheckable
                                showCheckedStrategy={TreeSelect.SHOW_CHILD}
                                //treeLine={{ showLeafIcon: false }}
                                showSearch={false}
                                treeDefaultExpandAll
                                maxTagCount={0}
                                maxTagPlaceholder={selected => {
                                    return selected.length >= availableCategoryFilterValues.length ? categoryFilterOptions.All : `+${selected.length}`;
                                }}
                                placeholder={categoryFilterOptions.All}
                                bordered={false}
                                showArrow
                                suffixIcon={<DownOutlined />}
                                style={{ width: 'auto', minWidth: 68 }}
                                dropdownMatchSelectWidth={false}
                                dropdownStyle={{ minWidth: 280 }}
                                dropdownClassName="notificationInsideElement"
                                getPopupContainer={trigger => trigger.parentElement}
                            />
                        </>
                    }
                </Col>
            </Row>
            <Row className="notificationList">
                <Skeleton className={"notificationInsideElement"} loading={loading}>
                {
                    messages.map((msg, idx) => 
                        <div key={idx}> 
                            <Divider style={{ margin: '3px 0' }} /> 
                            {React.createElement(notificationListItem, { ...msg, messages, countUnread, readFilter, categoryFilter, pagination, refreshUserNotification, updateReadStatus })} 
                        </div>
                    )
                }
                {
                    messages.length === 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }
                </Skeleton>
            </Row>
            <Pagination style={{ textAlign: 'center', marginTop: 16 }} current={pagination.current} total={pagination.total} showSizeChanger={pagination.showSizeChanger} onChange={handleOnPageChange} />
        </Card>
    );
}

const notificationListItem = props => {

    const { messages, readFilter, categoryFilter, pagination } = props;
    const { refreshUserNotification, updateReadStatus } = props;
    const { message_id, module, sub_module, doc_code, desc_key, desc_param, href, is_read, message_dt } = props;
    const [ showMore, setShowMore ] = useState(false);

    const removeMessage = async () => {
        let message = { ...messages.find(msg => msg.message_id === message_id), removed: true };
        let isUpdateSuccess = await upsertMessage(message);
        if (isUpdateSuccess) {
            let current = Math.ceil((pagination.total-1)/pagination.pageSize) >= pagination.current ? pagination.current : (pagination.current-1 > 0 ? pagination.current-1 : 1);
            refreshUserNotification(readFilter, "", pagination.pageSize, current, categoryFilter);
        }
    }

    const unfollow = async () => {
        let isUpdateSuccess = await unfollowNotification(module, doc_code);
        if (isUpdateSuccess) {
            Message.success(getText('notification.msgUnfollowSuccess'));
        } else {
            Message.error(getText('notification.msgUnfollowFail'));
        }
    }

    const handleOnClickNotificationList = e => {
        if ((href??'') !== '')
            history.push(`${process.env.PUBLIC_URL}${href}`);
        updateReadStatus(true, message_id);
        //setNotificationListVisible(false);
    }

    const handleMenuClick = e => {
        switch (e.key) {
            case "1":
                console.log('click', e.item.props.children);
                updateReadStatus(!is_read, message_id);
                break;
            case "2":
                console.log('click', e.item.props.children);
                removeMessage();
                break;
            case "3":
                console.log('click', e.item.props.children);
                unfollow();
                break;
            default:
                console.log('click');
        }
    }
    
    const handleOnClickRead = () => updateReadStatus(!is_read, message_id);

    const menu = (
        <Menu onClick={handleMenuClick} className='notificationInsideElement'>
            <Menu.Item key="1">
                <CheckOutlined />&nbsp;
                {!is_read && getText('notification.lblNotificationListItemMenuOption1a')}
                {is_read && getText('notification.lblNotificationListItemMenuOption1b')}
            </Menu.Item>
            <Menu.Item key="2">
                <DeleteOutlined />&nbsp;
                {getText('notification.lblNotificationListItemMenuOption2')}
            </Menu.Item>
            <Menu.Item key="3">
                <DisconnectOutlined />&nbsp;
                {module === "booking" && `${getText('notification.lblNotificationListItemMenuOption3a')}${doc_code}`}
            </Menu.Item>
        </Menu>
    );
    
    let html_desc = "";
    if (["notification.msgBookingNewOperationRemark", "notification.msgBookingNewPricingRemark",
        "notification.msgConsolidationNewOperationRemark", "notification.msgConsolidationNewPricingRemark"
    ].includes(desc_key))
    {
        html_desc = `<div>${getText(desc_key)}</div>`;
        for (const [key, value] of Object.entries(desc_param)) 
        {
            html_desc = html_desc.replace(`{${key}}`, value);
        }
    }

    if (["notification.msgBookingUpdateSailingA2", "notification.msgConsolidationUpdateSailingA2",
        "notification.msgBookingUpdateRateOPA234", "notification.msgConsolidationUpdateRateOPA234"].includes(desc_key))
    {
        desc_param.is_or_are = desc_param.is_or_are??"are";
        if (Array.isArray(desc_param.field_names))
        {
            desc_param.is_or_are = desc_param.field_names.length > 1 ? "are" : "is";
            desc_param.field_names = desc_param.field_names.join(", ");
        }
    }

    return (
        <div className="notificationListItem">
            <Row className="readBar">
                <div className={`readIndicator ${is_read ? 'read' : 'unread'}`} onClick={handleOnClickRead}></div>
            </Row>
            <Row className="moduleIcon">
                {getModuleIcon(module, sub_module)}
            </Row>
            <Row onClick={handleOnClickNotificationList} className="context">
                <Col data-unread-msg={!is_read}>
                    {["notification.msgBookingNewOperationRemark", "notification.msgBookingNewPricingRemark",
                        "notification.msgConsolidationNewOperationRemark", "notification.msgConsolidationNewPricingRemark"
                    ].includes(desc_key) ?
                        <div className="braft-output-content" style={{overflowX: "auto"}} dangerouslySetInnerHTML={{__html: html_desc}}></div>
                        : multiLine(getText(desc_key, desc_param))
                    }
                    {
                        showMore === true &&
                        <>
                            <br/>
                            {
                                desc_key === "notification.msgBookingUpdateSailingA2" && Array.isArray(desc_param.updated_sailing_detail) && 
                                desc_param.updated_sailing_detail.map( d => 
                                    <>{multiLine(getText("notification.msgBookingUpdateSailingA2Detail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgBookingUpdateRouting" && Array.isArray(desc_param.updated_routing_detail) && 
                                desc_param.updated_routing_detail.map( d => 
                                    <>{multiLine(getText("notification.msgBookingUpdateRoutingDetail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgBookingUpdateTotalRate" && (desc_param.contract_no??'') !== '' && 
                                <>{multiLine(desc_param.contract_no)}</>
                            }
                            {
                                desc_key === "notification.msgBookingUpdateTotalRate" && Array.isArray(desc_param.updated_total_rate_detail) && 
                                desc_param.updated_total_rate_detail.map( d => 
                                    <>{multiLine(getText("notification.msgBookingUpdateTotalRateDetail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgBookingUpdateRateOPA234" && Array.isArray(desc_param.a2_change_detail) && 
                                desc_param.a2_change_detail.map( d => 
                                    <>{multiLine(getText("notification.msgBookingUpdateRateOPA2Detail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgBookingUpdateRateOPA234" && Array.isArray(desc_param.a3_change_detail) && 
                                desc_param.a3_change_detail.map( d => 
                                    <>{multiLine(getText("notification.msgBookingUpdateRateOPA3Detail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgBookingUpdateRateOPA234" && Array.isArray(desc_param.a4_field_change_detail) && 
                                desc_param.a4_field_change_detail.map( d => 
                                    <>{multiLine(getText("notification.msgBookingUpdateRateOPA4FieldDetail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgBookingUpdateRateOPA234" && Array.isArray(desc_param.a4_tab_change_detail) && 
                                desc_param.a4_tab_change_detail.map( d => 
                                    <>{multiLine(getText("notification.msgBookingUpdateRateOPA4TabDetail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgConsolidationUpdateSailingA2" && Array.isArray(desc_param.updated_sailing_detail) && 
                                desc_param.updated_sailing_detail.map( d => 
                                    <>{multiLine(getText("notification.msgConsolidationUpdateSailingA2Detail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgConsolidationUpdateTotalRate" && (desc_param.contract_no??'') !== '' && 
                                <>{multiLine(desc_param.contract_no)}</>
                            }
                            {
                                desc_key === "notification.msgConsolidationUpdateTotalRate" && Array.isArray(desc_param.updated_total_rate_detail) && 
                                desc_param.updated_total_rate_detail.map( d => 
                                    <>{multiLine(getText("notification.msgConsolidationUpdateTotalRateDetail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgConsolidationUpdateRateOPA234" && Array.isArray(desc_param.a2_change_detail) && 
                                desc_param.a2_change_detail.map( d => 
                                    <>{multiLine(getText("notification.msgConsolidationUpdateRateOPA2Detail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgConsolidationUpdateRateOPA234" && Array.isArray(desc_param.a3_change_detail) && 
                                desc_param.a3_change_detail.map( d => 
                                    <>{multiLine(getText("notification.msgConsolidationUpdateRateOPA3Detail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgConsolidationUpdateRateOPA234" && Array.isArray(desc_param.a4_field_change_detail) && 
                                desc_param.a4_field_change_detail.map( d => 
                                    <>{multiLine(getText("notification.msgConsolidationUpdateRateOPA4FieldDetail", d))}</>
                                )
                            }
                            {
                                desc_key === "notification.msgConsolidationUpdateRateOPA234" && Array.isArray(desc_param.a4_tab_change_detail) && 
                                desc_param.a4_tab_change_detail.map( d => 
                                    <>{multiLine(getText("notification.msgConsolidationUpdateRateOPA4TabDetail", d))}</>
                                )
                            }
                            {
                                statusUpdateDescKeys.includes(desc_key) && (desc_param.status_message??"").length > 0 &&
                                <>{multiLine(desc_param.status_message)}</>
                            }
                            {
                                (
                                    (desc_key === "notification.msgBookingUpdateSailingA2" && Array.isArray(desc_param.updated_sailing_detail)) ||
                                    (desc_key === "notification.msgBookingUpdateRouting" && Array.isArray(desc_param.updated_routing_detail)) ||
                                    (desc_key === "notification.msgBookingUpdateTotalRate" && ((desc_param.contract_no??'') !== '' || Array.isArray(desc_param.updated_total_rate_detail))) ||
                                    (desc_key === "notification.msgBookingUpdateRateOPA234" && (Array.isArray(desc_param.a2_change_detail) || Array.isArray(desc_param.a3_change_detail) || Array.isArray(desc_param.a4_field_change_detail) || Array.isArray(desc_param.a4_tab_change_detail))) ||
                                    (statusUpdateDescKeys.includes(desc_key) && (desc_param.status_message??"").length > 0) ||

                                    (desc_key === "notification.msgConsolidationUpdateSailingA2" && Array.isArray(desc_param.updated_sailing_detail)) ||
                                    (desc_key === "notification.msgConsolidationUpdateTotalRate" && ((desc_param.contract_no??'') !== '' || Array.isArray(desc_param.updated_total_rate_detail))) ||
                                    (desc_key === "notification.msgConsolidationUpdateRateOPA234" && (Array.isArray(desc_param.a2_change_detail) || Array.isArray(desc_param.a3_change_detail) || Array.isArray(desc_param.a4_field_change_detail) || Array.isArray(desc_param.a4_tab_change_detail)))
                                ) &&
                                <a className="notificationInsideElement" onClick={e => { e.stopPropagation(); setShowMore(false); }}>Hide</a>
                            }
                        </>
                    }
                    {
                        showMore !== true &&
                        (
                            (desc_key === "notification.msgBookingUpdateSailingA2" && Array.isArray(desc_param.updated_sailing_detail)) ||
                            (desc_key === "notification.msgBookingUpdateRouting" && Array.isArray(desc_param.updated_routing_detail)) ||
                            (desc_key === "notification.msgBookingUpdateTotalRate" && ((desc_param.contract_no??'') !== '' || Array.isArray(desc_param.updated_total_rate_detail))) ||
                            (desc_key === "notification.msgBookingUpdateRateOPA234" && (Array.isArray(desc_param.a2_change_detail) || Array.isArray(desc_param.a3_change_detail) || Array.isArray(desc_param.a4_field_change_detail) || Array.isArray(desc_param.a4_tab_change_detail))) ||
                            (statusUpdateDescKeys.includes(desc_key) && (desc_param.status_message??"").length > 0) ||

                            (desc_key === "notification.msgConsolidationUpdateSailingA2" && Array.isArray(desc_param.updated_sailing_detail)) ||
                            (desc_key === "notification.msgConsolidationUpdateTotalRate" && ((desc_param.contract_no??'') !== '' || Array.isArray(desc_param.updated_total_rate_detail))) ||
                            (desc_key === "notification.msgConsolidationUpdateRateOPA234" && (Array.isArray(desc_param.a2_change_detail) || Array.isArray(desc_param.a3_change_detail) || Array.isArray(desc_param.a4_field_change_detail) || Array.isArray(desc_param.a4_tab_change_detail)))
                        ) &&
                        <a className="notificationInsideElement" onClick={e => { e.stopPropagation(); setShowMore(true); }}>Show more</a>
                    }
                    {
                        desc_key === "notification.msgMessengerMessage" &&
                        <a>See more</a>
                    }
                </Col>
                <Col data-unread-msg={!is_read}>
                    {getMessageDate(message_dt)}
                </Col>
            </Row>
            <Row type="flex" style={{ justifyContent: 'center' }}>
                <Col>
                    <Dropdown overlay={menu} trigger={['click']} align={{ offset: ['-92%', 0] }}>
                        <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                            <MoreOutlined style={{ transform: 'rotate(90deg)' }}/>
                        </a>
                    </Dropdown>
                </Col>
                <Col>
                    <DeleteOutlined style={{ verticalAlign: 'bottom' }} type="delete" onClick={removeMessage}/>
                </Col>
            </Row>
        </div>
    );
}

class NotificationBellButtonGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: null,
            profile_id: 0,
            messages: [],
            countUnread: 0,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 100,
                showSizeChanger: true,
                size: ""
            },
            readFilter: "All",
            categoryFilter: [],
            availableCategoryFilterValues: [],
            searchText: "",
            notificationListVisible: false,
            availableEventCodes: [],
            isLoadingRemarkImage: true
        }
    }

    componentDidMount() {
        let { token, profile_id, readFilter, searchText, pagination } = this.state;
        if (profile_id !== Auth.getProfile().profile_id)
        {
            this.setAvailableEventCodes();
            this.setState({ profile_id: Auth.getProfile().profile_id });
        }

        if (token !== Auth.getToken() )
        {
            this.refreshUserNotification(readFilter, searchText, pagination.pageSize, pagination.current);
            subscribeUserNotification(this.handleRefreshUserNotificationBySignalR);

            this.setState({ token: Auth.getToken() });
        }
    }

    componentDidUpdate() {
        let { token, profile_id, readFilter, searchText, pagination } = this.state;
        if (profile_id !== Auth.getProfile().profile_id)
        {
            this.setAvailableEventCodes();
            this.setState({ profile_id: Auth.getProfile().profile_id });
        }

        if (token !== Auth.getToken())
        {
            this.handleStopSignarlR();
            this.refreshUserNotification(readFilter, searchText, pagination.pageSize, pagination.current);
            subscribeUserNotification(this.handleRefreshUserNotificationBySignalR);

            this.setState({ token: Auth.getToken() });
        }
    }

    componentWillUnmount() {
        this.handleStopSignarlR();
    }

    handleStopSignarlR = async () => {
        if (this.refreshUserNotificationBySignalRTimer) {
            clearTimeout(this.refreshUserNotificationBySignalRTimer);
        }
        stopSignalR(this.handleRefreshUserNotificationBySignalR);
    }

    updateReadStatus = async (newStatus, message_id) => {
        const { messages, countUnread } = this.state;
        let message = messages.find(msg => msg.message_id === message_id);
        if (message) 
        {
            upsertMessage({ ...message, is_read: newStatus !== false });
            message.is_read = newStatus !== false;
            this.setState({ messages, countUnread: (newStatus !== false ? (countUnread-1 >= 0 ? countUnread-1 : 0) : countUnread+1) });
        }
    }

    getCategoryFilterParam = categoryFilter => {
        const { availableCategoryFilterValues } = this.state;
        return (categoryFilter.length === 0 || availableCategoryFilterValues.every(v => categoryFilter.includes(v))) ? "All" : categoryFilter.join(",");
    }

    refreshUserNotification = async (readFilter, searchText, pageSize, current, categoryFilter = null) => {
        const { pagination } = this.state;
        const cf = categoryFilter ?? this.state.categoryFilter;

        getMessage(pageSize, current, readFilter, searchText, this.getCategoryFilterParam(cf)).then(async res => {
                
            //let bookingDict = [];
            //let consolDict = [];
            //let messengerDict = [];
            for(var i=0; i<res.messages.length; i++)
            {
                // if (["notification.msgBookingNewOperationRemark", "notification.msgBookingNewPricingRemark"].includes(res.messages[i].desc_key))
                // {
                //     let src = res.messages[i].desc_param.remark;
                //     while(src.indexOf("src=\"cid:") > -1)
                //     {
                //         src = src.substring(src.indexOf("src=\"cid:")+9);
                //         bookingDict.push({ idx: i, file_name: src.substring(0, src.indexOf('\"')) });
                //         src = src.substring(src.indexOf('\"'));
                //     }
                // } 
                // else if (["notification.msgConsolidationNewOperationRemark", "notification.msgConsolidationNewPricingRemark"].includes(res.messages[i].desc_key))
                // {
                //     let src = res.messages[i].desc_param.remark;
                //     while(src.indexOf("src=\"cid:") > -1)
                //     {
                //         src = src.substring(src.indexOf("src=\"cid:")+9);
                //         consolDict.push({ idx: i, file_name: src.substring(0, src.indexOf('\"')) });
                //         src = src.substring(src.indexOf('\"'));
                //     }
                // }
                // else if (res.messages[i].desc_key === "notification.msgMessengerMessage")
                // {
                //     let src = res.messages[i].desc_param.full_desc;
                //     while(src.indexOf("src=\"cid:") > -1)
                //     {
                //         src = src.substring(src.indexOf("src=\"cid:")+9);
                //         messengerDict.push({ idx: i, file_name: src.substring(0, src.indexOf('\"')) });
                //         src = src.substring(src.indexOf('\"'));
                //     }
                // }
                if (["notification.msgBookingNewOperationRemark", "notification.msgBookingNewPricingRemark",
                    "notification.msgConsolidationNewOperationRemark", "notification.msgConsolidationNewPricingRemark"
                ].includes(res.messages[i].desc_key))
                {
                    while(res.messages[i].desc_param.remark && res.messages[i].desc_param.remark.indexOf("<img") > -1)
                    {
                        let src = res.messages[i].desc_param.remark;
                        src = src.substring(src.indexOf("<img"));
                        src = src.substring(0, src.indexOf(">")+1);
                        res.messages[i].desc_param.remark = res.messages[i].desc_param.remark.replace(src, "&lt;image&gt;");
                    }
                } 
                else if (res.messages[i].desc_key === "notification.msgMessengerMessage")
                {
                    while(res.messages[i].desc_param.full_desc && res.messages[i].desc_param.full_desc.indexOf("<img") > -1)
                    {
                        let src = res.messages[i].desc_param.full_desc;
                        src = src.substring(src.indexOf("<img"));
                        src = src.substring(0, src.indexOf(">")+1);
                        res.messages[i].desc_param.full_desc = res.messages[i].desc_param.full_desc.replace(src, "&lt;image&gt;");
                    }
                }
            }
            
            // const requests = [];
            
            // if (bookingDict.length > 0)
            // {
            //     requests.push(loadBookingApprovalRemarkImage(res.messages, bookingDict));
            // }
            // if (consolDict.length > 0)
            // {
            //     requests.push(loadConsolidationRemarkImage(res.messages, consolDict));
            // }
            // if (messengerDict.length > 0)
            // {
            //     requests.push(loadMessengerMessageFullDescImage(res.messages, messengerDict));                
            // }
            // if (requests.length > 0)
            // {
            //     this.setState({ isLoadingRemarkImage: true });
            //     await Promise.all(requests);
            // }

            this.setState({
                pagination: { ...pagination, total: readFilter === 'All' ? res.total_count : res.unread_count , pageSize, current },
                messages: res.messages,
                countUnread: res.unread_count,
                isLoadingRemarkImage: false
            });
        });
    }

    refreshUserNotificationBySignalRTimer = null;
    pendingRefreshUserNotificationBySignalR = [];

    handleRefreshUserNotificationBySignalR = msgData => {
        let { availableEventCodes } = this.state;
        let accessRight = false;

        if (Array.isArray(availableEventCodes))
            accessRight = availableEventCodes.some(c => c.module === msgData.module && c.sub_module === msgData.sub_module && c.key == msgData.event_code);

        if (accessRight)
        {
            this.pendingRefreshUserNotificationBySignalR.push(msgData);

            clearTimeout(this.refreshUserNotificationBySignalRTimer);
            this.refreshUserNotificationBySignalRTimer = setTimeout(async () => {
                const msgDatas = this.pendingRefreshUserNotificationBySignalR;
                this.pendingRefreshUserNotificationBySignalR = [];

                try {
                    await this.refreshUserNotificationBySignalR(msgDatas);
                }
                catch (err) {
                    console.error(err);
                }
            }, 1000);
        }
    }


    refreshUserNotificationBySignalR = msgDatas => {
        let { readFilter, searchText, pagination, countUnread, categoryFilter } = this.state;
        let { pageSize, current } = pagination;

        getMessage(pageSize, current, readFilter, "", this.getCategoryFilterParam(categoryFilter)).then(async res => {
            msgDatas.forEach(msgData => {
                let msg = res.messages.find(msg => msg.guid === msgData.guid);
                
                try { msg.desc_param = JSON.parse(msg.desc_param); } catch(e) { console.log(e); };
                
                let html_desc = "";
                if (["notification.msgBookingNewOperationRemark", "notification.msgBookingNewPricingRemark",
                    "notification.msgConsolidationNewOperationRemark", "notification.msgConsolidationNewPricingRemark",
                    "notification.msgMessengerMessage"
                ].includes(msg.desc_key))
                {
                    html_desc = `<div>${getText(msg.desc_key)}</div>`;
                    for (const [key, value] of Object.entries(msg.desc_param)) 
                    {
                        html_desc = html_desc.replace(`{${key}}`, value);
                    }

                    //let dict = [];
                    // let src = html_desc;
                    // while(src.indexOf("src=\"cid:") > -1)
                    // {
                    //     src = src.substring(src.indexOf("src=\"cid:")+9);
                    //     dict.push({ file_name: src.substring(0, src.indexOf('\"')) });
                    //     src = src.substring(src.indexOf('\"'));
                    // }
                    // if (dict.length > 0)
                    // {
                    //     if (["notification.msgBookingNewOperationRemark", "notification.msgBookingNewPricingRemark"].includes(msg.desc_key))
                    //         html_desc = await loadBookingApprovalRemarkImage2(html_desc, msg, dict);
                    //     else if (["notification.msgConsolidationNewOperationRemark", "notification.msgConsolidationNewPricingRemark"].includes(msg.desc_key))
                    //         html_desc = await loadConsolidationRemarkImage2(html_desc, msg, dict);
                        // else if (msg.desc_key === "notification.msgMessengerMessage")
                        //     html_desc = await loadMessengerMessageFullDescImage2(html_desc, msg, dic);
                    //}
                    while(html_desc.indexOf("<img") > -1)
                    {
                        let src = html_desc;
                        src = src.substring(src.indexOf("<img"));
                        src = src.substring(0, src.indexOf(">")+1);
                        html_desc = html_desc.replace(src, "&lt;image&gt;");
                    }
                }
                
                Notification.info({
                    className: "notificationInsideElement",
                    key: msg.guid,
                    message: "",
                    description: (
                        <div 
                            className="notificationMessage"
                            style={{ wordBreak: "break-word", cursor: 'pointer', marginRight: '20px' }} 
                            onClick={() => {
                                if ((msg.href??'') !== '')
                                    history.push(`${process.env.PUBLIC_URL}${msg.href}`);
                                this.updateReadStatus(true, msg.message_id);
                                Notification.close(msg.guid);
                            }}
                        >
                            {
                                ["notification.msgBookingNewOperationRemark", "notification.msgBookingNewPricingRemark",
                                    "notification.msgConsolidationNewOperationRemark", "notification.msgConsolidationNewPricingRemark"
                                ].includes(msg.desc_key) ?
                                <div className="braft-output-content" style={{overflowX: "auto"}} dangerouslySetInnerHTML={{__html: html_desc}}></div>
                                : multiLine(getText(msg.desc_key, msg.desc_param))
                            }
                            {
                                msg.desc_key === "notification.msgBookingUpdateSailingA2" && Array.isArray(msg.desc_param.updated_sailing_detail) && 
                                <>
                                    <br/>
                                    {
                                        msg.desc_param.updated_sailing_detail.map( d => 
                                            <>{multiLine(getText("notification.msgBookingUpdateSailingA2Detail", d))}</>
                                        )
                                    }
                                </>
                            }
                            {
                                msg.desc_key === "notification.msgBookingUpdateRouting" && Array.isArray(msg.desc_param.updated_routing_detail) && 
                                <>
                                    <br/>
                                    {
                                        msg.desc_param.updated_routing_detail.map( d => 
                                            <>{multiLine(getText("notification.msgBookingUpdateRoutingDetail", d))}</>
                                        )
                                    }
                                </>
                            }
                            {
                                (
                                    msg.desc_key === "notification.msgBookingUpdateRateOPA234" && (
                                        Array.isArray(msg.desc_param.a2_change_detail) 
                                        || Array.isArray(msg.desc_param.a3_change_detail)
                                        || Array.isArray(msg.desc_param.a4_field_change_detail)
                                        || Array.isArray(msg.desc_param.a4_tab_change_detail))
                                ) &&
                                <>
                                    <br/>
                                    {
                                        Array.isArray(msg.desc_param.a2_change_detail) && msg.desc_param.a2_change_detail.map( d => 
                                            <>{multiLine(getText("notification.msgBookingUpdateRateOPA2Detail", d))}</>
                                        )
                                    }
                                    {
                                        Array.isArray(msg.desc_param.a3_change_detail) && msg.desc_param.a3_change_detail.map( d => 
                                            <>{multiLine(getText("notification.msgBookingUpdateRateOPA3Detail", d))}</>
                                        )
                                    }
                                    {
                                        Array.isArray(msg.desc_param.a4_field_change_detail) && msg.desc_param.a4_field_change_detail.map( d => 
                                            <>{multiLine(getText("notification.msgBookingUpdateRateOPA4FieldDetail", d))}</>
                                        )
                                    }
                                    {
                                        Array.isArray(msg.desc_param.a4_tab_change_detail) && msg.desc_param.a4_tab_change_detail.map( d => 
                                            <>{multiLine(getText("notification.msgBookingUpdateRateOPA4TabDetail", d))}</>
                                        )
                                    }
                                </>
                            }
                            {
                                msg.desc_key === "notification.msgConsolidationUpdateSailingA2" && Array.isArray(msg.desc_param.updated_sailing_detail) && 
                                <>
                                    <br/>
                                    {
                                        msg.desc_param.updated_sailing_detail.map( d => 
                                            <>{multiLine(getText("notification.msgConsolidationUpdateSailingA2Detail", d))}</>
                                        )
                                    }
                                </>
                            }
                            {
                                msg.desc_key === "notification.msgConsolidationUpdateRateOPA234" 
                                    && (
                                        Array.isArray(msg.desc_param.a2_change_detail) 
                                        || Array.isArray(msg.desc_param.a3_change_detail)
                                        || Array.isArray(msg.desc_param.a4_field_change_detail)
                                        || Array.isArray(msg.desc_param.a4_tab_change_detail)) &&
                                <>
                                    <br/>
                                    {
                                        Array.isArray(msg.desc_param.a2_change_detail) && msg.desc_param.a2_change_detail.map( d => 
                                            <>{multiLine(getText("notification.msgConsolidationUpdateRateOPA2Detail", d))}</>
                                        )
                                    }
                                    {
                                        Array.isArray(msg.desc_param.a3_change_detail) && msg.desc_param.a3_change_detail.map( d => 
                                            <>{multiLine(getText("notification.msgConsolidationUpdateRateOPA3Detail", d))}</>
                                        )
                                    }
                                    {
                                        Array.isArray(msg.desc_param.a4_field_change_detail) && msg.desc_param.a4_field_change_detail.map( d => 
                                            <>{multiLine(getText("notification.msgConsolidationUpdateRateOPA4FieldDetail", d))}</>
                                        )
                                    }
                                    {
                                        Array.isArray(msg.desc_param.a4_tab_change_detail) && msg.desc_param.a4_tab_change_detail.map( d => 
                                            <>{multiLine(getText("notification.msgConsolidationUpdateRateOPA4TabDetail", d))}</>
                                        )
                                    }
                                </>
                            }
                            {
                                statusUpdateDescKeys.includes(msg.desc_key) && (msg.desc_param.status_message??"").length > 0 &&
                                <>
                                    <br/>
                                    <>{multiLine(msg.desc_param.status_message)}</>
                                </>
                            }
                            {
                                msg.desc_key === "notification.msgMessengerMessage" &&
                                <><a>See more</a></>
                            }
                        </div>
                    ),
                    placement: 'bottomRight',
                    duration: 0
                });
            });

            if (searchText === "")
            {
                this.setState({
                    pagination: { ...pagination, total: readFilter === 'All' ? res.total_count : res.unread_count , pageSize, current },
                    messages: res.messages,
                    countUnread: res.unread_count
                });
                this.forceUpdate(); // force update to refresh total count of page
            }
            else
                this.setState({ countUnread: countUnread+1 });
        }).catch(e => {
            console.log(`Refresh user notification fail: `, e);
        });
    }

    setAvailableEventCodes = async () => {
        let result = await getUserProfileAvailableEventCodes();
        this.setState({ availableEventCodes: result });
    }

    render() {
        const { messages, countUnread, pagination, readFilter, categoryFilter, searchText, notificationListVisible, isLoadingRemarkImage, availableEventCodes } = this.state;

        return (
            <>
                {
                    <BellButton 
                        notificationListVisible={notificationListVisible} 
                        setNotificationListVisible={val => this.setState({ notificationListVisible: val })}
                        countUnread={countUnread}
                    />
                }
                {
                    <NotificationList 
                        messages={messages}
                        countUnread={countUnread}
                        pagination={pagination}
                        readFilter={readFilter}
                        categoryFilter={categoryFilter}
                        searchText={searchText}
                        notificationListVisible={notificationListVisible}
                        loading={isLoadingRemarkImage}
                        refreshUserNotification={this.refreshUserNotification}
                        setNotificationListVisible={val => this.setState({ notificationListVisible: val })}
                        setMessages={val => this.setState({ messages: val })}
                        setCountUnread={val => this.setState({ countUnread: val })}
                        setReadFilter={val => this.setState({ readFilter: val })}
                        setCategoryFilter={val => this.setState({ categoryFilter: val })}
                        setAvailableCategoryFilterValues={val => this.setState({ availableCategoryFilterValues: val })}
                        setSearchText={val => this.setState({ searchText: val })}
                        setPagination={val => this.setState({ pagination: val })}
                        updateReadStatus={this.updateReadStatus}
                        availableEventCodes={availableEventCodes}
                    />
                }
            </>
        );
    };
}

export default withAuth(NotificationBellButtonGroup);